import React from 'react';

import {Loader} from '../../lib/loader/loader';
import {useRootMachine} from '../../hooks/useRootMachine';
import {useBookingMachine} from '../../hooks/useBookingMachine';

import {UnavailableTimeSlot} from '../unavailable-timeslot/unavailable-timeslot';
import {AvailabilityEmpty} from '../../lib/availability-empty/availability-empty';
import {BookingWeekDayPicker} from '../booking-week-day-picker/booking-week-day-picker';
import {BookingTimeslotPicker} from '../booking-timeslot-picker/booking-timeslot-picker';
import {BookingReschedule} from '../booking-reschedule/booking-reschedule';
import {BookingNotifyHostButton} from '../booking-notify-host-button/booking-notify-host-button';
import {BookingAvailabilityError} from '../booking-errors/booking-availability-error';

import css from './booking-date-time-picker.css';


export const BookingDateTimePicker = () => {
  const {rootState} = useRootMachine();
  const {bookingState} = useBookingMachine();

  // availability flow
  const isAvailabilityLoading = bookingState.matches({
    dateTimePicker: 'availabilityLoading',
  });
  const isAvailabilityNotifyHost = bookingState.matches({
    dateTimePicker: 'availabilityNotify',
  });
  const isAvailabilitySlots = bookingState.matches({
    dateTimePicker: 'availabilitySlots',
  });
  const isAvailabilityEmpty = bookingState.matches({
    dateTimePicker: 'availabilityEmpty',
  });

  // reschedule flow
  const isRescheduleFlow = rootState.matches('rescheduleFlow');
  const isTimeslotConfirmation = bookingState.matches({
    dateTimePicker: 'timeslotConfirmation',
  });
  const isRescheduleFormSubmitting = bookingState.matches({
    dateTimePicker: 'rescheduleFormSubmitting',
  });
  const isRetryReschedule = bookingState.matches({
    dateTimePicker: 'retryReschedule',
  });
  const hasUnavailableTimeSlotForReschedule = bookingState.matches({
    dateTimePicker: 'unavailableTimeSlotForReschedule',
  });
  const hasAvailabilityError = bookingState.matches({
    dateTimePicker: 'availabilityError',
  });

  const showBookingTimeslotPicker =
    isAvailabilitySlots ||
    isTimeslotConfirmation ||
    isRetryReschedule ||
    isRescheduleFormSubmitting;

  return (
    <div className={css.bookingDateTimePicker}>
      {!isAvailabilityNotifyHost && !hasUnavailableTimeSlotForReschedule && (
        <BookingWeekDayPicker />
      )}
      {isAvailabilityLoading && <Loader />}
      {hasUnavailableTimeSlotForReschedule && (
        <UnavailableTimeSlot isRescheduleFlow={isRescheduleFlow} />
      )}
      {showBookingTimeslotPicker && <BookingTimeslotPicker />}
      {hasAvailabilityError && <BookingAvailabilityError />}
      {isAvailabilityEmpty && <AvailabilityEmpty />}
      {!isAvailabilityNotifyHost &&
        !hasUnavailableTimeSlotForReschedule &&
        isRescheduleFlow && <BookingReschedule />}
      {isAvailabilityNotifyHost && <BookingNotifyHostButton />}
    </div>
  );
};
